import { useMediaQuery } from "@mui/material";

export const useOcIsMobile = () => {
  return useMediaQuery("(max-width:600px)");
};

export default useOcIsMobile;
